export default __webpack_public_path__ + "static/media/testimonials-header-image-mobile.ce655b10.png";